import { createFileRoute } from '@tanstack/react-router'
import { requireRoles } from '@/lib/middleware'
import { MyComplaints } from '@/features/participant/complaints'

export const Route = createFileRoute(
  '/_authenticated/_organization/my-complaints/'
)({
  beforeLoad: async () => requireRoles(['client', 'primary_contact']),
  component: MyComplaints,
})
